import { Component, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { ConfigService } from "../core/services/config.service";
import { UserSerivice } from "../services/user.service";
import { WantedcreditService } from "../services/wantedcredit.service";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit {
  isUserLoggedIn: boolean;
  showMaintenance = false;
  maintenanceMessage = "";
  maintenanceRetryMessage = "";

  constructor(
    private authService: MsalService,
    private userService: UserSerivice,
    private wantedCreditService: WantedcreditService,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.showMaintenance = this.configService.maintenanceMode;
    this.maintenanceMessage = this.configService.maintenanceMessage;
    this.maintenanceRetryMessage = this.configService.maintenanceRetryMessage;
    this.userService.currentProfile().subscribe((p) => {
      this.isUserLoggedIn = !!p;
    });
  }

  login() {
    this.authService.loginRedirect();
  }

  logout() {
    this.authService.logoutRedirect();
    this.wantedCreditService.clearRequestId();
  }
}
